module.exports = "<div style=\"width:100%;height:100%;position: relative;\">\n  <iframe #examEditor [src]=\"currentAppUrl\" class=\"examEditorContainer\" src=\"\" width=\"100%\" height=\"100%\" (load)=\"onLoadExamIframe($event)\">\n\n  </iframe>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/exam/exam.component.html
// module id = ./src/app/exam/exam.component.html
// module chunks = main